import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dynamicTranslate',
  standalone: true
})
export class DynamicTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }
  transform(value: string): string {
    if (value === null || value === undefined) {
      return "";
    }

    return this.translateService.instant(value);
  }
}
